import { FeatureListItemWrapper } from './style';
import SubscriptionPlanType from 'crono-fe-common/types/enums/subscriptionPlanType';
import { colors } from 'crono-fe-common/theme';
import CheckMarkIcon from 'crono-fe-common/icons/Icon-CheckMark';
import PlusSmallIcon from 'crono-fe-common/icons/Icon-Plus-Small';
import { cn } from 'utils/style-utils';

interface IProps {
  type: SubscriptionPlanType;
  feature: string;
  firstFeature: boolean;
}

const FeatureListItem = ({ type, feature, firstFeature }: IProps) => {
  return (
    <FeatureListItemWrapper
      className={cn({
        'includes-previous-feature':
          firstFeature && type !== SubscriptionPlanType.PRO,
        'includes-previous-feature--custom':
          firstFeature && type === SubscriptionPlanType.Custom,
        'flex-row-reverse justify-end': type === SubscriptionPlanType.PRO,
      })}
    >
      {!firstFeature &&
        type !== SubscriptionPlanType.FREE_TRIAL &&
        type !== SubscriptionPlanType.PRO && (
          <span
            className={cn('feature-checkmark', {
              'feature-checkmark--custom': type === SubscriptionPlanType.Custom,
            })}
          >
            <PlusSmallIcon
              color={
                type === SubscriptionPlanType.ULTRA
                  ? colors.prospecting
                  : colors.customPlanPurple
              }
              size={16}
            />
          </span>
        )}

      <p
        className={cn(
          firstFeature && type !== SubscriptionPlanType.PRO
            ? 'text-sm'
            : 'text-xs',
        )}
      >
        {feature}
      </p>

      {(firstFeature || type === SubscriptionPlanType.PRO) && (
        <span
          className={cn('min-w-6 min-h-6 includes-previous-feature-icon', {
            'free-trial-feature': type === SubscriptionPlanType.FREE_TRIAL,
          })}
        >
          <CheckMarkIcon color={colors.darkGreen} size={16} strokeWidth={2} />
        </span>
      )}
    </FeatureListItemWrapper>
  );
};

export default FeatureListItem;
